var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "169px",
    height: "158px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: "2px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "none",
    d: "M82.068,1.249 C109.481,3.126 135.325,14.151 149.830,28.433 C164.952,42.961 168.735,60.748 166.300,81.825 C163.556,103.092 154.841,122.460 140.278,134.078 C125.923,146.233 105.720,150.639 84.817,154.383 C44.405,163.513 5.848,132.898 1.102,88.314 C-1.091,45.526 27.748,-2.964 82.068,1.249 L82.068,1.249 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(255, 255, 255)",
    d: "M82.615,11.621 C106.260,13.242 128.553,22.764 141.064,35.101 C154.109,47.648 157.371,63.011 155.271,81.216 C152.904,99.584 145.387,116.312 132.825,126.347 C120.443,136.846 103.016,140.651 84.986,143.885 C50.128,151.770 16.869,125.328 12.775,86.820 C10.883,49.864 35.760,7.982 82.615,11.621 L82.615,11.621 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.c51e0eaf4ffe441c0eddc8fe4011e049.svg";
export { ForwardRef as ReactComponent };